import { cn } from 'lib/utils';

interface Props {
  isActive?: boolean;
  label: string;
  onClick?: () => void;
}

export const CategoryItem = ({ isActive, label, onClick }: Props) => {
  return (
    <li
      className={cn(
        'w-full rounded-[8px] flex items-center py-5 px-3  font-[ggsm]',
        'text-[var(--primary-color)]',
        [isActive && 'bg-[var(--primary-color)] text-[#fff]'],
        [!isActive && 'bg-[#FAFAFA] hover:bg-[#D1E7BF] cursor-pointer'],
      )}
      onClick={onClick}
    >
      {label}
    </li>
  );
};

